import type { ReactNode } from "react";

export const EmptyState = ({
  icon,
  title,
  description,
  actions,
}: {
  icon?: ReactNode;
  title: string;
  description?: string;
  actions?: ReactNode;
}) => (
  <div className="flex flex-col items-center rounded-lg border border-dashed border-border bg-muted/20 px-6 py-12 text-center">
    {icon && (
      <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full border border-border bg-card text-muted-foreground">
        {icon}
      </div>
    )}
    <h3 className="type-heading-sm">{title}</h3>
    {description && (
      <p className="mt-2 max-w-md type-body-sm text-muted-foreground">{description}</p>
    )}
    {actions && <div className="mt-6">{actions}</div>}
  </div>
);
